export const DROP_POSITIONS = {
  before: 'before',
  after: 'after',
  inside: 'inside',
};
